class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange(e) {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.updateInventoryStatus();
    this.updateStaffAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();
    this.setInventoryNotice();

    if (!this.currentVariant) {
      this.toggleAddButton(false, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  connectedCallback() {
    this.getVariantData();
    this.updateOptions();
    this.updateMasterId();
    this.updateVariantStatuses();
    this.setInventoryNotice();
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('.product-form__input'), (wrapper) => {
      const checked = wrapper.querySelector(':checked');
      return checked ? checked.value : undefined;
    });
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGridySlider = document.getElementById(`slider-${this.dataset.section}`);
    const thumbnailsGridySlider = document.getElementById(`thumbnail-slider-${this.dataset.section}`);
    
    if (mediaGridySlider) {
      mediaGridySlider.scrollToSlideByID(
        `item-${this.currentVariant.featured_media.id}`
      );
    }
    
    if (thumbnailsGridySlider) {
      thumbnailsGridySlider.scrollToSlideByID(`thumbnail-item-${this.currentVariant.featured_media.id}`)
    }

    const isDesktop = window.matchMedia('(min-width: 1024px)').matches;
    const isGrid = mediaGridySlider.dataset.desktopEnabled === 'false' ? true : false;
    if (isDesktop && isGrid) {
      document.getElementById(`item-${this.currentVariant.featured_media.id}`)?.scrollIntoView();
    }
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}, #product-form-${this.dataset.section}-product-buy-bar`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(variant => this.querySelector(':checked').value === variant.option1);
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];

    inputWrappers.forEach((option, index) => {
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')]
      let availableOptionInputsValue;

      if (index === 0) {
        availableOptionInputsValue = this.variantData
        .filter(variant => variant.available)
        .map(variant => variant.option1);
        this.setInputAvailability(optionInputs, availableOptionInputsValue)
        
      } else {
        const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
        availableOptionInputsValue = selectedOptionOneVariants.filter(variant => variant.available && variant[`option${ index }`] === previousOptionSelected).map(variantOption => variantOption[`option${ index + 1 }`]);
        this.setInputAvailability(optionInputs, availableOptionInputsValue)
      }
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    const unavailableText = this.dataset.comingSoon === 'true'
          ? window.variantStrings.coming_soon
          : window.variantStrings.unavailable_with_option;
    listOfOptions.forEach(input => {
      const isAvailable = listOfAvailableOptions.includes(input.getAttribute('value'));
      const text = isAvailable
        ? input.value
        : unavailableText.replace('[value]', input.getAttribute('value'));
      
      input.classList.toggle('disabled', !isAvailable);

      const labelSpan = input.nextElementSibling.querySelector('.visually-hidden') ||
      input.nextElementSibling.querySelector('span');
      
      if (labelSpan) {
        labelSpan.textContent = text;
      }

      if (input.checked) {
        const buttonLabel = input.closest('custom-dropdown').querySelector('.custom-dropdown__label');
        buttonLabel.textContent = text;
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  updateStaffAvailability() {
    // Staff-only DC availability indicator (snippets/product-staff-dc-availability.liquid).
    // Re-renders from the map fetched on page load; it never refetches on variant change.
    const staffAvailability = document.querySelector(`staff-dc-availability[data-section="${this.dataset.section}"]`);
    if (!staffAvailability || typeof staffAvailability.setVariant !== 'function') return;
    staffAvailability.setVariant(this.currentVariant);
  }

  updateInventoryStatus() {
    this.productInventoryNode = document.querySelector('[data-product-inventory]');

    if (!this.productInventoryNode || !window.inventories || !window.inventories[this.dataset.productId]) return;

    this.inventoryThreshold = parseInt(this.productInventoryNode.dataset.threshold);
    this.showQuantityInStock = this.productInventoryNode.dataset.showQuantityInStock;

    const variantInventoryObject = window.inventories[this.dataset.productId][this.currentVariant?.id];

    if (!this.currentVariant || !this.currentVariant.inventory_management) {
      this.toggleInventoryQuantity(false);
      this.toggleIncomingInventory(false);

      return;
    }

    if (this.currentVariant.inventory_management === 'shopify') {
      if (variantInventoryObject.quantity <= 0 && variantInventoryObject.incoming === 'true' && variantInventoryObject.quantity < this.inventoryThreshold) {
        this.toggleInventoryQuantity(false);
        this.toggleIncomingInventory(true, variantInventoryObject.next_incoming_date);
      } else {
        this.toggleInventoryQuantity(true, variantInventoryObject.quantity);
        this.toggleIncomingInventory(false);
      }
    }
  }

  toggleInventoryQuantity(show, quantity) {
    if (show === false) {
      this.productInventoryNode.classList.add('hide');
      return;
    }

    this.productInventoryNode.classList.remove('inventory-status--in-stock', 'inventory-status--low', 'inventory-status--sold-out', 'inventory-status--sold-out-continue-selling');

    if (this.currentVariant && this.currentVariant.available && parseInt(quantity) <= parseInt(this.inventoryThreshold) && parseInt(quantity) > 0) {
      this.productInventoryNode.classList.add('inventory-status--low');
      if (!this.showQuantityInStock === 'true') {
        this.productInventoryNode.firstElementChild.textContent = window.variantStrings.inventory.few_left_with_quantity.replace('[quantity]', quantity);
      } else {
        this.productInventoryNode.firstElementChild.textContent = window.variantStrings.inventory.few_left;
      }
    } else if (this.currentVariant && this.currentVariant.available && parseInt(quantity) > parseInt(this.inventoryThreshold)) {
      this.productInventoryNode.classList.add('inventory-status--in-stock');
      if (!this.showQuantityInStock === 'true') {
        this.productInventoryNode.firstElementChild.textContent = window.variantStrings.inventory.in_stock_with_quantity.replace('[quantity]', quantity);
      } else {
        this.productInventoryNode.firstElementChild.textContent = window.variantStrings.inventory.in_stock;
      }
    } else if (this.currentVariant && this.currentVariant.available && parseInt(quantity) < 1) {
      this.productInventoryNode.classList.add('inventory-status--sold-out-continue-selling');
      this.productInventoryNode.firstElementChild.textContent = window.variantStrings.inventory.out_of_stock_continue_selling;
    } else {
      this.productInventoryNode.classList.add('inventory-status--sold-out');
      this.productInventoryNode.firstElementChild.textContent = window.variantStrings.inventory.out_of_stock;
    }

    this.productInventoryNode.classList.remove('hide');
  }

  toggleIncomingInventory(show, date) {
    const incomingInventoryNode = document.querySelector('[data-incoming-inventory]');
    if (!incomingInventoryNode) return;

    if (show == false && incomingInventoryNode) {
      incomingInventoryNode.classList.add('hide');

      return;
    }

    let string = !date ?
      window.variantStrings.inventory.waiting_for_stock : 
      window.variantStrings.inventory.will_be_in_stock_after.replace('[date]', date);

    incomingInventoryNode.classList.remove('hide');
    incomingInventoryNode.firstElementChild.textContent = string;
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const destinationBuyBarInfo = document.getElementById(
          `buy-bar-info-${this.dataset.section}`
        );
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const buyBarInfoSource = html.getElementById(`buy-bar-info-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        if (source && destination) destination.innerHTML = source.innerHTML;
        if (source && destinationBuyBarInfo) destinationBuyBarInfo.innerHTML = buyBarInfoSource.innerHTML;

        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('hidden', skuSource.classList.contains('hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('hidden');
        this.toggleAddButton(!this.currentVariant.available, this.currentVariant.available ? window.variantStrings.soldOut : window.variantStrings.notifyMe);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    const multiplyButtons = productForm.querySelectorAll('.btn--add-multiplier');
    if (!addButton) return;

    if (disable) {
      // addButton.setAttribute('disabled', 'disabled');
      if (modifyClass) addButton.setAttribute('data-bis-trigger', '');
      if (text) addButtonText.textContent = text;
      if (multiplyButtons) {
        multiplyButtons.forEach(button => {
          // button.disabled = true;
        });
      }
    } else {
      addButton.removeAttribute('disabled');
      if (modifyClass) addButton.removeAttribute('data-bis-trigger');
      if (this.dataset.isPreorder == 'true') {
        addButtonText.textContent = window.variantStrings.preOrder;
      } else {
        addButtonText.textContent = window.variantStrings.addToCart;
      }
      if (multiplyButtons) {
        multiplyButtons.forEach(button => {
          button.removeAttribute('disabled');
        });
      }
    }

    const productForm_BuyBar = document.getElementById(
      `product-form-${this.dataset.section}-product-buy-bar`
    );
    if (productForm_BuyBar) {
      const addButton_BuyBar = productForm_BuyBar.querySelector('[name="add"]');
      const addButtonText_BuyBar = productForm_BuyBar.querySelector(
        '[name="add"] > span'
      );

      if (disable) {
        addButton_BuyBar.setAttribute("disabled", "disabled");
        if (text) addButtonText_BuyBar.textContent = text;
      } else {
        addButton_BuyBar.removeAttribute("disabled");
        if (this.dataset.isPreorder == "true") {
          addButtonText_BuyBar.textContent = window.variantStrings.preOrder;
        } else {
          addButtonText_BuyBar.textContent = window.variantStrings.addToCart;
        }
      }
    }
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('hidden');

    const button_BuyBar = document.getElementById(
      `product-form-${this.dataset.section}-product-buy-bar`
    );
    const addButton_BuyBar = button_BuyBar.querySelector('[name="add"]');
    const addButtonText_BuyBar = button_BuyBar.querySelector(
      '[name="add"] > span'
    );
    const price_BuyBar = document.getElementById(
      `price-${this.dataset.section}-product-buy-bar`
    );
    if (!addButton_BuyBar) return;
    addButtonText_BuyBar.textContent = window.variantStrings.unavailable;
    if (price_BuyBar) price_BuyBar.classList.add("hidden");
  }

  getInventoryData() {
    if (this.inventoryData) return this.inventoryData;
      const script = document.getElementById(`inventory-quantities-${this.dataset.section}`);
      this.inventoryData = script ? JSON.parse(script.textContent) : {};
    return this.inventoryData;
  }

  createInventoryTree(variant_data, selected_options) {
    const inventory_data = this.getInventoryData();

    return variant_data.reduce((options, variant) => {
      Object.keys(options).forEach(index => {
        if (variant[index] === null) return;

        const matchesEveryOtherOption = selected_options
          .filter(option => option.index !== index)
          .every(option => variant[option.index] === option.value);

        if (matchesEveryOtherOption) {
          options[index][variant[index]] = inventory_data[variant.id];
        }
      });
      return options;
    }, {
      option1: {},
      option2: {},
      option3: {}
    });
  }

  setInventoryNotice() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.inventory_management) return;

    const variant_data = this.getVariantData();
    if (variant_data) {
      const selected_options = this.currentVariant.options.map((value, index) => {
        return {
          value,
          index: `option${index+1}`
        };
      });
      const inventory_tree = this.createInventoryTree(variant_data, selected_options);
      const options = Array.from(this.querySelectorAll('.product-form__input'));
      options.forEach((fieldset, i) => {
        const inventory = Object.values(inventory_tree)[i];
        if (fieldset.querySelectorAll('input').length) {
          const isDropdown = fieldset.querySelector('custom-dropdown');
          fieldset.querySelectorAll('input').forEach((input, input_i) => {
            const buttonSpan = isDropdown ? fieldset.querySelector('.custom-dropdown__label') : null;
            let inventoryNotice = false;
            if (inventory[input.value] <= this.dataset.lowStockThreshold) {
              inventoryNotice = true;
            }
            if (isDropdown && !input.classList.contains('disabled')) {
              const labelSpan = input.nextElementSibling.querySelector('span');
              if (labelSpan) {
                labelSpan.textContent = inventoryNotice
                      ? `${input.value} - ${this.dataset.lowStockText}`
                      : input.value;
              }
              if (buttonSpan && input.checked) {
                  buttonSpan.textContent = inventoryNotice
                      ? `${input.value} - ${this.dataset.lowStockText}`
                      : input.value;
                }
            }
          });
        }
      });
    }
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class CustomDropdown extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('.custom-dropdown__button');
    this.list = this.querySelector('.custom-dropdown__list');
    this.overlay = this.querySelector('.custom-dropdown__overlay')
    this.handleOutsideClick = this.handleOutsideClick.bind(this);
  }
  connectedCallback() {
    this.button.addEventListener('click', () => {
      this.toggle();
    });
    this.list.addEventListener('click', (e) => {
      if (e.target.closest('label') || e.target.closest('.custom-dropdown__back')) this.close();
    });
    this.overlay.addEventListener('click', (e) => {
        this.close();
      })
    document.addEventListener('click', this.handleOutsideClick);
  }
  disconnectedCallback() {
    document.removeEventListener('click', this.handleOutsideClick);
  }
  handleOutsideClick(e) {
    if (!this.contains(e.target)) {
      this.close();
    }
  }
  toggle() {
    this.button.getAttribute('aria-expanded') === 'true' ? this.close() : this.open();
  }
  open() {
    this.button.setAttribute('aria-expanded', 'true');
    this.classList.add('is-open');
    if (window.matchMedia('(max-width:767px)').matches) {
        document.body.classList.add('overflow-hidden');
    }
  }
  close() {
    this.button.setAttribute('aria-expanded', 'false');
    this.classList.remove('is-open');
    if (!document.querySelector('.custom-dropdown.is-open')){
        document.body.classList.remove('overflow-hidden');
    }
  }
}

customElements.define('custom-dropdown', CustomDropdown);


class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });

    this.updateLegends();
  }

  updateLegends() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    fieldsets.forEach((fieldset) => {
      const legend = fieldset.querySelector('legend [data-variant-legend]');
      const selectedOption = Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked);
      legend.textContent = selectedOption.getAttribute('value');
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductBuyBar extends HTMLElement {
  constructor() {
    "use strict";
    super();

    let classes = { show: "show" };
    let mainProductForm = document.querySelector(".product-form");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // In view -> Hide bar
            this.classList.remove(classes.show);
          } else if (window.scrollY > 200) {
            // Out of view AND scrolled a little from top -> Show bar
            this.classList.add(classes.show);
          }
        });
      },
      { threshold: 0.25 }
    );

    observer.observe(mainProductForm);

    // This script is loaded in product-template.liquid --> Footer observer after DOM ready
    document.addEventListener("DOMContentLoaded", function () {
      let siteFooter = document.querySelector("footer.footer");
      if (!siteFooter) return;
      observer.observe(siteFooter);
    });
  }
}
customElements.define("product-buy-bar", ProductBuyBar);

class UpsellCard extends HTMLElement {
  constructor() {
    super();
    this.select = this.querySelector('select');
    this.image = this.querySelector('.card-media img');

    if (this.select) {
      this.select.addEventListener('change', (event) => {
        const selectedOption = event.target.options[event.target.selectedIndex];
        const newImgSrc = selectedOption.getAttribute('data-variant-img-src');
        if (newImgSrc) { this.updateImage(newImgSrc) }
      });
    }
  }

  updateImage(newImgSrc) {
    if (this.image) {
      this.image.src = newImgSrc;
    }
  }
}

customElements.define('upsell-card', UpsellCard);

// When our OOS button is clicked, forward to Klaviyo's hidden BIS button to open the modal.
document.addEventListener('click', function (e) {
  const trigger = e.target.closest('[data-bis-trigger]');
  if (!trigger) return;
  e.preventDefault();
  const klaviyoBtn = document.querySelector('#klaviyo-bis-button-container button');
  if (!klaviyoBtn) return;
  klaviyoBtn.setAttribute('type', 'button');
  klaviyoBtn.click();
});
